import React, { useState } from "react";
import { useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import HardBreak from "@tiptap/extension-hard-break";
import {
  MenuButtonBold,
  MenuButtonItalic,
  MenuControlsContainer,
  MenuDivider,
  MenuSelectHeading,
  MenuButtonBulletedList,
  MenuButtonOrderedList,
  RichTextEditorProvider,
  RichTextField,
  RichTextContent,
} from "mui-tiptap";
import Placeholder from '@tiptap/extension-placeholder'
// Import your CSS stylesheets
import "../styles/variables.css";
import "../styles/layoutStyles.css";
import "../styles/buttonStyles.css";
import "../styles/textStyles.css";

type NoteContainerProps = {
  onSaveContent: (newContent: string) => void;
};

const NoteContainer: React.FC<NoteContainerProps> = ({ onSaveContent }) => {
  const [isFocused, setIsFocused] = useState(false);

  const editor = useEditor({
    extensions: [StarterKit, Placeholder.configure({
        // Use a placeholder:
        placeholder: 'Start typing your session notes here...',
        // Use different placeholders depending on the node type:
        // placeholder: ({ node }) => {
        //   if (node.type.name === 'heading') {
        //     return 'What’s the title?'
        //   }

        //   return 'Can you add some further context?'
        // },
      }),],
    content: "",
    onUpdate: ({ editor }) => {
        const newContent = editor.getHTML();
        onSaveContent(newContent);
      },
  });

  if (!editor) return null;

  return (
    <div style={{ margin: "1rem 0rem" }}>
      <RichTextEditorProvider editor={editor}>
      <div className="editor-focused" style={{ height: "20rem", overflowY: "auto" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              border: "none",
            }}
          >
            <MenuControlsContainer>
              <MenuSelectHeading />
              <MenuDivider />
              <MenuButtonBold />
              <MenuButtonItalic />
              <MenuDivider />
              <MenuButtonBulletedList />
              <MenuButtonOrderedList />
            </MenuControlsContainer>
          </div>
          <div style={{ padding: "2rem 1rem" }}>
          <RichTextContent />
          </div>
        </div>
      </RichTextEditorProvider>
    </div>
  );
};

export default NoteContainer;
